import { UserQuoteSearchResponse } from '@lio/api-types';
import { UserQuoteSearchQueryParams } from '@services/user';
import { userQueryKey } from '@services/user/keys';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchUserQuotes = (queryParams: UserQuoteSearchQueryParams, enabled = true) => {
  const client = useClient();
  const { searchType, isInProgress, userId } = queryParams;
  let url = `user/${userId}/quote?searchType=${searchType}&pageLimit=${queryParams.pageLimit ?? 50}`;
  if (isInProgress !== undefined) {
    url = `${url}&isInProgress=${isInProgress}`;
  }
  const result = useQuery({
    queryKey: userQueryKey.searchUserQuotesWithParams(queryParams),
    queryFn: () => client.get(url).json<UserQuoteSearchResponse>(),
    placeholderData: keepPreviousData,
    enabled: !!userId && enabled,
  });
  return { ...result, searchUserQuotes: result.data };
};
